export default class CustomerMobile{
    public mobile = "";
    public verificationCode = "";
}